import {useGetInfiniteUsers} from '@/features/users/queries/useGetInfiniteUsers'
import {useMemo} from 'react'

/**
 * External structures are a handful of placeholder users flagged with `isExternalStructure` on the
 * backend, so a single page holds them all.
 */
const EXTERNAL_STRUCTURES_LIMIT = 100

/**
 * Ids of the users that represent an external structure.
 *
 * Needed because the flag does not survive every path a consultant can enter the event form from:
 * `InputSelectUser` rebuilds the user by hand when picking from the team tab, and the teams endpoint does
 * not serialise `isExternalStructure` (`treatment_request_team.resource.ts`). Resolving by id keeps the
 * behaviour identical whichever tab the consultant was picked from. Once the backend exposes the flag on
 * the team member too, this can be dropped in favour of the value already carried by the form.
 */
export const useExternalStructureUserIds = () => {
    const {remappedData} = useGetInfiniteUsers({
        limit: EXTERNAL_STRUCTURES_LIMIT,
        filters: {isExternalStructure: true}
    })

    return useMemo(() => new Set(remappedData.map(user => user.id)), [remappedData])
}
